import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import validateUUID from '../../../utils/validateUUID';
import {getFeeServerFromFormik} from '../CreateBuilder/BuilderDAInitialFees';
import {
  getPotContactId,
  updateRecsVarsProps,
  upsertBuilderHeader,
} from './builderHelpers';

export const saveTransfer = async (props: updateRecsVarsProps): Promise<string> => {
  const {accountId, values, destinationPots, contacts = []} = props;
  const {contact, urgency, urgencyReason} = values;
  const transfer = values.transfer!;
  const destinationPotId = transfer.destinationValues?.existingPotId;
  const mainPlanPot = destinationPots?.find((x) => x.id === destinationPotId);

  const ovrecommendId = await upsertBuilderHeader(props, {
    action: OVRecommendActionEnum.TRANSFER,
    accountId: validateUUID(accountId),
    goalId: validateUUID(values.goal?.id),
    isNewPlanRequired: false,
    contactId: getPotContactId(contact),
    urgency,
    urgencyReason,
    productProviderId: mainPlanPot?.productProvider?.id,
    productNameId: mainPlanPot?.productName?.id,
  });

  const sources = Object.values(transfer.transferSources ?? {});

  const existingSources = sources
    .filter((s) => !s.isShellPlan)
    .map((s) => ({
      sourcePotId: validateUUID(s.id)!,
      isFull: !!s.full,
      isInSpecie: !!s.inSpecie,
      singleClientAmount: Number(s.singleClientAmount) || 0,
      initialFeeId: validateUUID(s.initialFee) ?? null,
      sppInitialFee: getFeeServerFromFormik(values.isSppDa, s.legacyInitialFee) ?? null,
    }));

  const newSources = sources
    .filter((s) => s.isShellPlan)
    .map((s) => ({
      contactId: validateUUID(s.contactId) ?? null,
      isFull: !!s.full,
      isInSpecie: !!s.inSpecie,
      singleClientAmount: Number(s.singleClientAmount) || 0,
      initialFeeId: validateUUID(s.initialFee) ?? null,
      sppInitialFee: getFeeServerFromFormik(values.isSppDa, s.legacyInitialFee) ?? null,
      productProviderId: validateUUID(s.planProvider)!,
      productNameId: validateUUID(s.planType)!,
      planNumber: s.accountNumber ?? '',
      isDataGather: s.isDataGather === 'yes',
      isAuthorityHeld: s.isAuthorityHeld === 'yes',
      currentPlanValue: Number(s.planValue) || 0,
    }));

  await props.upsertBuilderTransfer({
    variables: {
      ovrecommendId: validateUUID(ovrecommendId)!,
      destinationPotId: validateUUID(destinationPotId)!,
      existingSources,
      newSources,
    },
  });

  return ovrecommendId;
};
